<div
  role="dialog"
  aria-modal="true"
  class="modal-wrapper"
  data-cy="unselect_dialog"
  [attr.aria-label]="config.ariaLabel"
  [style.backgroundColor]="config.backgroundColor"
>
  @if (showHeader) {
    <div
      class="modal-header"
      [class.has-logo]="challengeImage.type === 'logo'"
      [style.backgroundColor]="config.header.backgroundColor"
      [style.backgroundImage]="config.header.backgroundImage | transformUrl"
    >
      @switch (data.challenge.type) {
        @case (OfferType.STEP) {
          @if (challengeImage.path) {
            <div [class]="challengeImage.type">
              <img
                class="brand-image responsive-width"
                [alt]="config.header.logo?.alternativeText || ''"
                [src]="challengeImage.path"
              />
            </div>
          }
        }
        @case (OfferType.FREQUENCY) {
          @if (frequencyHeaderImage; as headerImage) {
            <img
              class="frequency-header-image"
              data-cy="frequency_header_image"
              [src]="headerImage.imageUrl"
              [alt]="headerImage.alternativeText"
            />
          }
        }
      }
    </div>
  }

  @if (titlePicture; as picture) {
    <div class="title-image-wrapper">
      <img
        class="image"
        [src]="picture.imageUrl"
        [alt]="picture.alternativeText"
      />
    </div>
  }

  @if (config.title.label) {
    <p
      class="modal-title"
      [style]="{
        color: config.title.color,
        fontFamily: config.title.fontFamily,
      }"
      [innerHTML]="config.title.label | safe"
    ></p>
  }

  <p
    class="modal-body"
    data-cy="last_selection_dialog_content"
    [style]="{
      color: config.body.color,
      fontFamily: config.body.fontFamily,
    }"
    [innerHTML]="config.body.label | safe"
  ></p>

  <div class="modal-footer" [class]="config.actionButtons.variant">
    <b2c-button
      class="close-btn"
      data-cy="confirmation_btn"
      (click)="confirmUnselection()"
      [title]="confirmButton.ariaLabel"
      [attr.aria-label]="confirmButton.ariaLabel"
      [styles]="confirmButtonStyles"
    >
      {{ confirmButton.label }}</b2c-button
    >

    @if (closeButton) {
      <b2c-button
        class="close-btn"
        data-cy="close_btn"
        (click)="closeDialog()"
        [title]="closeButton.ariaLabel"
        [attr.aria-label]="closeButton.ariaLabel"
        [styles]="closeButtonStyles"
      >
        {{ closeButton.label }}</b2c-button
      >
    }
  </div>
</div>
